import { useState, useRef, useEffect, useCallback } from 'react';

const useStateWithCallback = (initializer) => {
  const [state, setState] = useState(initializer);
  const callback = useRef();

  const setStateWithCallback = useCallback((setter, cb) => {
    callback.current = cb;
    setState(setter);
  }, []);

  useEffect(() => {
    if (callback.current) {
      callback.current(state);
      callback.current = null;
    }
  }, [state]);

  return [state, setStateWithCallback];
};

export default useStateWithCallback;
